/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Return_Position_Err_InvalidInputs */

const vi_return_position_err_invalid = /** @type {(inputs: Return_Position_Err_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kệ nhập hoàn không hợp lệ: kệ phải đang hoạt động và dùng cho lô hàng bán.`)
};

/**

* @param {Return_Position_Err_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const return_position_err_invalid = /** @type {((inputs?: Return_Position_Err_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Return_Position_Err_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_return_position_err_invalid(inputs)
});